export default __webpack_public_path__ + "static/aud_mob-e1c715f3b4fe5c7ca90a70ab3387f1ad.png";